define([], () => {
    return window => {
        function trackPageView(event) {
            window.analytics.page(event.payload.path, {path: event.payload.path});
        }

        function trackServerCall(event) {
            window.analytics.track('serverCall', event);
        }

        function trackEvent(event) {
            window.analytics.track(event.eventName, event);
        }

        function trackJourney(event) {
            window.analytics.track('journey', event.payload);
        }

        function identify(event) {
            window.analytics.identify(event.payload.userId);
        }

        return {
            trackPageView,
            trackServerCall,
            trackEvent,
            trackJourney,
            identify
        };
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/tracking/adapters/SegmentIOAdapter.js